module.exports = __webpack_public_path__ + "static/work-with-us-dac34aa1fc6ab80163ec8cbab2328603.svg";